import { render, staticRenderFns } from "./Refactoring.vue?vue&type=template&id=1e58a034&"
import script from "./Refactoring.vue?vue&type=script&lang=js&"
export * from "./Refactoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports